/* Menu Gallery */
(() => {
  const init = gallery => {
    if (gallery.dataset.menuGalleryReady) return;
    const q = (s, el = gallery) => el.querySelector(s);
    const qa = (s, el = gallery) => [...el.querySelectorAll(s)];
    const viewport = q('.menu-gallery-slider');
    const track = q('.menu-gallery-track');
    const slides = qa('.menu-gallery-slide');
    const lb = q('.menu-lightbox');
    const lbViewport = q('.menu-lightbox-slider');
    const lbTrack = q('.menu-lightbox-track');
    if (!viewport || !track || !slides.length) return;

    gallery.dataset.menuGalleryReady = 'true';
    const dots = qa('.menu-gallery-dot');
    const lbDots = lb ? qa('.menu-lightbox-dot', lb) : [];
    const current = q('.menu-gallery-current');
    const total = q('.menu-gallery-total');
    let index = 0, isOpen = false, oldOverflow = '', ignoreClickUntil = 0;

    if (total) total.textContent = slides.length;
    if (lb && lb.parentElement !== document.body) document.body.append(lb);

    const wrap = n => (n % slides.length + slides.length) % slides.length;
    const set = (el, animate = true) => {
      if (!el) return;
      el.style.transition = animate ? '' : 'none';
      el.style.transform = 'translate3d(-' + index * 100 + '%,0,0)';
      if (!animate) requestAnimationFrame(() => el.style.transition = '');
    };
    const update = (n, animate = true) => {
      index = wrap(n);
      set(track, animate);
      set(lbTrack, animate);
      [...dots, ...lbDots].forEach((dot, i) => {
        const active = (i % slides.length) === index;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (current) current.textContent = index + 1;
    };
    const next = () => update(index + 1);
    const prev = () => update(index - 1);
    const open = n => {
      if (!lb || !lbTrack) return;
      update(n, false);
      isOpen = true;
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        lb.classList.add('open');
        q('.menu-lightbox-close', lb)?.focus();
      });
    };
    const close = () => {
      if (!lb) return;
      isOpen = false;
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = oldOverflow;
      setTimeout(() => { if (!isOpen) lb.hidden = true; }, 180);
    };
    const drag = (box, movingTrack) => {
      if (!box || !movingTrack) return;
      let id = null, start = 0, dx = 0;
      const end = event => {
        if (id === null || (event && event.pointerId !== id)) return;
        const threshold = Math.min(96, box.clientWidth * .18);
        movingTrack.style.transition = '';
        if (Math.abs(dx) > threshold) {
          dx < 0 ? next() : prev();
          ignoreClickUntil = Date.now() + 300;
        } else update(index);
        if (box.hasPointerCapture(id)) box.releasePointerCapture(id);
        id = null; dx = 0; gallery.classList.remove('is-dragging');
      };
      box.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        id = e.pointerId; start = e.clientX; dx = 0;
        movingTrack.style.transition = 'none';
        box.setPointerCapture(id);
        gallery.classList.add('is-dragging');
      });
      box.addEventListener('pointermove', e => {
        if (e.pointerId !== id) return;
        dx = e.clientX - start;
        movingTrack.style.transform = 'translate3d(calc(-' + index * 100 + '% + ' + dx + 'px),0,0)';
      });
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      box.addEventListener('dragstart', e => e.preventDefault());
    };

    q('.menu-gallery-prev')?.addEventListener('click', prev);
    q('.menu-gallery-next')?.addEventListener('click', next);
    q('.menu-lightbox-prev', lb)?.addEventListener('click', prev);
    q('.menu-lightbox-next', lb)?.addEventListener('click', next);
    q('.menu-lightbox-close', lb)?.addEventListener('click', close);
    dots.forEach((dot, n) => dot.addEventListener('click', () => update(n)));
    lbDots.forEach((dot, n) => dot.addEventListener('click', () => update(n)));
    /* Delegation keeps a normal tap/click separate from a swipe. */
    viewport.addEventListener('click', event => {
      if (Date.now() < ignoreClickUntil) return;
      const slide = event.target.closest('.menu-gallery-slide');
      const slideIndex = slides.indexOf(slide);
      if (slideIndex !== -1) open(slideIndex);
    });
    if (lb) {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      lb.addEventListener('click', e => { if (e.target === lb) close(); });
    }
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && isOpen) close();
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });
    drag(viewport, track);
    drag(lbViewport, lbTrack);
    update(0, false);
  };
  const all = () => document.querySelectorAll('.menu-gallery').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', all) : all();
  document.addEventListener('shopify:section:load', all);
})();
